import { gql } from 'graphql-tag';
/* AppSync */
import _ from 'lodash'
import appsyncclient from '../../api/AppSync';
import { animalResearchs } from "../mock/animalResearch";
import { slideResearchs } from "../mock/slideResearch";
import actions from "../constant";
import { listStudy, getStudy, mutateCreateStudy, mutateRemoveStudy, mutateUpdataStudy } from "../../graphql/study/studyProfile";
import { mutateCreateAnimal, getAnimals, getAnimal, mutateUpdateAnimal } from "../../graphql/study/animalProfile";
import { createSlide, updateSlide, getSlide } from "../../graphql/study/slideProfile";
import { createNote, updateNote, removeNote } from "../../graphql/study/noteProfile";
import { mutateCreateAnnotation, mutateUpdateAnnotation, getAnnotationGql, delAnnotation } from "../../graphql/study/annotationProfile"
import { getShareS3Path } from '../../graphql/study/s3Profile';

const initialState = {
  tableData: [],
  slideInfo: {
    findingInhadn: "默认参数",
    finding: "默认参数",
    serverity: "默认参数",
    serverity1: "默认参数",
    laterality: "默认参数",
    directionality: "默认参数"
  }
};

export const animalResearchReducer = (state=initialState, action) => {
  switch ( action.type ) {
    case actions.GET_STUDY_TABLES:
      return { 
        ...state, tableData: action.payload.map((item) => {
          item.childrens = [];
          return item;
        })
      }

    case actions.GET_ANIMALS: {
      let arr = state.tableData.map((item, index) => {
        if(item.ID === action.id) {
          return { ...item, childrens: action.payload}
        };
        return {...item};
      });
      return {...state, tableData: [...arr]}
    }

    case actions.CREATE_STUDY: {
      return {...state, tableData: [ ...state.tableData, action.payload]} 
    }

    case actions.GET_NOTE_SLIDE: {
      return {...state, slideInfo: { ...state.slideInfo, ...action.payload}}
    }
    default:
      return state
  }
};


const changeSlideInfo = (data) => {
  const someKeys = ["InterimSlideNote", "SlideNote", "SlideObservation"]
  for(const someKey of someKeys){
    data[someKey] = _.map(data[someKey], (v) => {v.type = someKey; return v})
  }
  // 将PPM变成object
  if(data['PPM']){
    data.PPM = JSON.parse(data.PPM)
  }
  return data
}

export const getSlideInfo = (params, callBack) => async (dispatch, getState) => {
  try{
    let result = await appsyncclient.query({
      query: gql(getSlide),
      variables: params,
      fetchPolicy: 'no-cache',
    });
    if(result.data?.getSlide) {
      if(callBack){
        const data = changeSlideInfo(result.data.getSlide)
        callBack(data)
      }
    }
  }catch(error) {
    callBack && callBack(null)
  }
}

export const getStudyInfo = (params, callBack) => async (dispatch, getState) => {
  try{
    let result = await appsyncclient.query({
      query: gql(getStudy),
      variables: params,
      fetchPolicy: 'no-cache',
    })
  }catch(error) {
    callBack && callBack(null)
  }
};

export const getAnimalInfo = (params, callBack) => async (dispatch, getState) => {
  try{
    let result = await appsyncclient.query({
      query: gql(getAnimal),
      variables: params,
      fetchPolicy: 'no-cache',
    });
    
    if(result?.data?.getAnimal) {
      callBack && callBack(result.data.getAnimal)
    }
  }catch(error) {
    callBack && callBack(null)
  }
}

// create study
export const createStudy = ( params, callBack) => async(dispatch, getState) => {
  try {
    const result = await appsyncclient.mutate({
      mutation: gql(mutateCreateStudy),
      variables: params
    });
    // dispatch(getStudyTable())
    dispatch({ type: actions.CREATE_STUDY, payload: result.data.createStudy });
    callBack && callBack(result.data.createStudy)
  }catch (error) {
    callBack && callBack(null)
    throw new Error("run createStudy error", error);
    
  }
};

// create animal
export const mutCreateAnimal = (params, callBack) => async(dispatch, getState) => {
  try {
    const result = await appsyncclient.mutate({
      mutation: gql(mutateCreateAnimal),
      variables: params
    });
    
    dispatch(listAnimal({ id: result?.data?.createAnimal?.StudyID || "" }));
    callBack && callBack()
  }catch(error) {
    throw new Error("run createAnimal error", error)
  }
};

// animalList
export const listAnimal = (params) => async(dispatch, getState) => {
  try{
    const response = await appsyncclient.query({
      query: gql(getAnimals),
      variables: params,
      fetchPolicy: 'no-cache',
    });

    let arr = [];
    // 此处应该生成你想要的数据 将node slide animal 整理成一条数据
    if(response?.data?.getAnimals) {
      response.data.getAnimals.forEach((element, index) => {
        if(element?.Slides?.length) {
          arr = [
            ...arr, 
            ...element.Slides.map((item) => ({ ...element, newAnimalsId: element.ID, ...item }))
          ];
        }else {
          arr = [...arr, { ...element, newAnimalsId: element.ID }];
        }
      });
    };
    params.callBack && params.callBack(arr)
    dispatch({ type: actions.GET_ANIMALS, id: params.id, payload: arr || []})
  }catch(error) {
    params.callBack && params.callBack(null)
  }
}

// studyList
export const  getStudyTable = (callBack) => async(dispatch, getState) => {
  try {
    const response = await appsyncclient.query({
      query: gql(listStudy),
      variables: {},
      fetchPolicy: 'no-cache',
    });
    dispatch({ type: actions.GET_STUDY_TABLES, payload: response?.data?.listStudies || []});
    callBack && callBack(response.data.listStudies || []);
  } catch (error) {
    console.log('fetchGetProfile error: ', error);
    callBack && callBack(null);
  };
};

// 编辑表格的数据
export const getSlideEditInfo = ({ type }) => (dispatch, getState) => {
  
  switch (type) {
    case "note":
      dispatch({ type: actions.GET_NOTE_SLIDE, payload: {...initialState.slideInfo, findingInhadn: "1"} })
      break;
    case "interim":
      dispatch({ type: actions.GET_NOTE_SLIDE, payload:{...initialState.slideInfo, findingInhadn: "2"} })
      break;
    case "observation":
      dispatch({ type: actions.GET_NOTE_SLIDE, payload: {...initialState.slideInfo, findingInhadn: "3"} })
      break;
    default:
      break;
  }
};

// remove study
export const removeStudy = (params) => async (dispatch, getState) => {
  try {
    const result = await appsyncclient.mutate({
      mutation: gql(mutateRemoveStudy),
      variables: params
    });
    dispatch(getStudyTable())
  }catch(error) {
    
  }
};

// update study
export const putUpdateStudy = (params, callBack) => async (dispatch, getState) => {
  try {
    const result = await appsyncclient.mutate({
      mutation: gql(mutateUpdataStudy),
      variables: params
    });
    
    if(result?.data?.updateStudy) {
      callBack && callBack(result.data.updateStudy);
    }
    // dispatch(getStudyTable());
  }catch(error) {
  }
};

// update animal
export const putUpdateAnimal = (params, callBack) => async (dispatch, getState) => {
  try {
    const result = await appsyncclient.mutate({
      mutation: gql(mutateUpdateAnimal),
      variables: params
    });
    if(result?.data?.updateAnimal) {
      callBack && callBack(result.data.updateAnimal);
    };
    // dispatch(listAnimal({ id: result?.data?.updateAnimal?.StudyID || "" }))
  }catch (error) {
    callBack && callBack(null);
  }
};

// create Slide
export const mutateCreateSlide = (params, callBack) => async (dispatch, getState) => {
  try {
    const result = await appsyncclient.mutate({
      mutation: gql(createSlide),
      variables: params
    });
    dispatch(listAnimal({ id: result?.data?.createSlide?.StudyID || "" }));
    callBack && callBack()
  }catch(error) {
    
  }
};

// update Slide
export const putUpdateSlide = (params, callBack) => async (dispatch, getState) => {
  try {
    const result = await appsyncclient.mutate({
      mutation: gql(updateSlide),
      variables: params
    });
    if(result?.data?.updateSlide) {
      callBack && callBack(result.data.updateSlide);
    }
    // dispatch(listAnimal({ id: result?.data?.updateSlide?.StudyID || "" }))
  }catch(error) {
  }
};

// crete note
export const mutateCreateNote = (params, callBack) => async (dispatch, getState) => {
  try {
    const result = await appsyncclient.mutate({
      mutation: gql(createNote),
      variables: params
    });
    if(result?.data?.createNote) {
      callBack && callBack(result.data.createNote)
    }
  }catch(error) {
    callBack && callBack()
  }
};

// edit note
export const putUpdateNode = (params, callBack) => async (dispatch, getState) => {
  try {
    const result = await appsyncclient.mutate({
      mutation: gql(updateNote),
      variables: params
    });
    if(result?.data?.updateNote) {
      callBack && callBack(result.data.updateNote)
    }
  } catch(error) {

  }
};

export const createAnnotation = (params, callBack) => async (dispatch, getState) => {
  try {
    const result = await appsyncclient.mutate({
      mutation: gql(mutateCreateAnnotation),
      variables: params
    });
    if(result?.data?.createAnnotation) {
      callBack && callBack(result.data.createAnnotation)
    }
  } catch(error) {

  }
};

export const putUpdateAnnotation = (params, callBack) => async (dispatch, getState) => {
  try {
    const result = await appsyncclient.mutate({
      mutation: gql(mutateUpdateAnnotation),
      variables: params
    });
    if(result?.data?.updateAnnotation) {
      callBack && callBack(result.data.updateAnnotation)
    }
  } catch(error) {

  }
};

export const getAnnotation = (params, callBack) => async (dispatch, getState) => {
  try {
    const response = await appsyncclient.query({
      query: gql(getAnnotationGql),
      variables: params,
      fetchPolicy: 'no-cache',
    });
    if(response?.data?.getAnnotation) {
      callBack && callBack(response.data.getAnnotation || {});
    }
  } catch (error) {
    callBack && callBack(null);
  };
};

export const removeAnnotation = (params, callBack)=> async (dispatch, getState) => {
  try {
    const result = await appsyncclient.mutate({
      mutation: gql(delAnnotation),
      variables: params
    });
    if(result?.data?.deleteAnnotation) {
      callBack && callBack(result.data.deleteAnnotation)
    }
  } catch(error) {

  }
};


export const retrieveS3SharePath = (params, callBack)=> async (dispatch, getState) => {
  try {
    const result = await appsyncclient.query({
      query: gql(getShareS3Path),
      variables: params,
      fetchPolicy: 'no-cache',
    });
    if(result?.data?.getShareS3Path) {
      callBack && callBack(result.data.getShareS3Path)
    }
  } catch(error) {
    console.error(error)
  }
};